// Hardware-scoped device fingerprint (stable across browsers on the same device).
// Combines screen geometry, timezone, hardware concurrency, device memory, platform
// and touch support so switching browsers (Chrome ↔ Safari ↔ Firefox) on the same
// physical device produces the same fingerprint — but a truly different device does not.
// Cached in localStorage so we don't recompute every call.
function fnv1a(str) {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
  }
  return ("00000000" + h.toString(16)).slice(-8);
}

function computeHardwareFingerprint() {
  const s = window.screen || {};
  const nav = navigator || {};
  const parts = [
    `${s.width || 0}x${s.height || 0}`,
    `d${s.colorDepth || 0}`,
    `dpr${Math.round((window.devicePixelRatio || 1) * 10)}`,
    Intl.DateTimeFormat().resolvedOptions().timeZone || "",
    `hc${nav.hardwareConcurrency || 0}`,
    `dm${nav.deviceMemory || 0}`,
    `pf${(nav.platform || "").slice(0, 20)}`,
    `tp${(nav.maxTouchPoints || 0)}`,
  ];
  return "hw-" + fnv1a(parts.join("|"));
}

export function getDeviceFingerprint() {
  const KEY = "cc_device_fp_v2";
  const LEGACY = "cc_device_fp";
  let fp = localStorage.getItem(KEY);
  const current = computeHardwareFingerprint();
  if (!fp || fp !== current) {
    fp = current;
    localStorage.setItem(KEY, fp);
    // Retire legacy per-browser UUID so we no longer send it.
    try { localStorage.removeItem(LEGACY); } catch (e) { /* ignore */ }
  }
  return fp;
}
